import { render, staticRenderFns } from "./OrbatTree.vue?vue&type=template&id=17255396&scoped=true"
import script from "./OrbatTree.vue?vue&type=script&lang=ts"
export * from "./OrbatTree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17255396",
  null
  
)

export default component.exports